import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import Limite from './componentes/Limite'
import './estilos.css'
import './espacio.css'
import './bases.css'
import './avanzado.css'
import './adjuntos.css'

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <BrowserRouter>
      <Limite>
        <App />
      </Limite>
    </BrowserRouter>
  </StrictMode>,
)
